<template>
  <div class="w-full h-full">
    <AlertDialog :open="openUploadModal" @update:open="(o) => !o && (openUploadModal = false)">
      <AlertDialogContent class="max-w-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle>Add verified transactions</AlertDialogTitle>
          <AlertDialogDescription>Upload the verified transaction csv to the system</AlertDialogDescription>
        </AlertDialogHeader>
        <div>
          <input id="rewardImgUpload" type="file" @change="uploadFile" ref="fileInput" accept=".csv" />
        </div>
        <AlertDialogFooter class="gap-2">
          <AlertDialogCancel @click="openUploadModal = false">Cancel</AlertDialogCancel>
          <AlertDialogAction :disabled="uploadCSV == undefined" @click="uploadTransactions()">Upload</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
    <div class="flex items-center gap-3 mb-4">
      <ShoppingBasket class="w-7 h-7 text-foreground" />
      <h1 class="text-2xl font-semibold tracking-tight">Retailer settlements</h1>
    </div>
    <section class="mb-4">
      <div class="flex items-baseline justify-between mb-3">
        <h2 class="text-lg font-semibold">Upload transactions</h2>
      </div>
    </section>
    <Card>
      <CardHeader class="flex-row items-start justify-between gap-4 space-y-0">
        <div class="flex-1">
          <CardTitle>Cashback transactions</CardTitle>
        </div>
        <div class="flex items-center gap-2">
          <Button
            size="sm"
            @click="
              () => {
                openUploadModal = true
                verification = verificationObject
              }
            "
          >Submit transactions</Button>
        </div>
      </CardHeader>
      <CardContent>
        <DataTable
          :headers="headersTable1"
          :items="receivables"
          :loading="loading"
          :error="error"
          @retry="getTransactionVerifications(serverOptions.page - 1, serverOptions.rowsPerPage)"
          v-model:server-options="serverOptions"
          :server-items-length="serverItemsLength"
        >
          <template #item-createdOn="{ createdOn }">
            <span class="text-sm text-muted-foreground whitespace-nowrap">{{ niceDateTime(createdOn) }}</span>
          </template>

          <template #item-downloadCSV="verificationObject">
            <div class="flex justify-end items-center gap-1">
              <Button
                variant="outline"
                size="sm"
                @click="download(verificationObject)"
              >Download CSV</Button>
            </div>
          </template>
          <template #item-received="verificationObject">
            <Button
              size="sm"
              v-if="!verificationObject.sentToSupplier"
              @click="markAsSent(verificationObject)"
            >Mark as sent</Button>
            <span v-else class="text-sm text-muted-foreground">Sent to supplier</span>
          </template>
          <template #item-upload="verificationObject">
            <Button
              size="sm"
              v-if="!verificationObject.receivedFromSupplier && verificationObject.sentToSupplier"
              @click="
                () => {
                  openUploadModal = true
                  verification = verificationObject
                }
              "
            >Submit transactions</Button>
            <span v-else-if="!verificationObject.sentToSupplier" class="text-sm text-muted-foreground">
              You need to send the transaction list first
            </span>
            <span v-else class="text-sm text-muted-foreground">Recieved successfully</span>
          </template>
        </DataTable>
      </CardContent>
    </Card>
  </div>
</template>

<script setup></script>

<script>
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Button,
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
  AlertDialogCancel,
} from '@boogi/ui'
import { ShoppingBasket } from 'lucide-vue-next'
import { DateTime } from 'luxon'
import { DataTable } from '@boogi/ui'

export default {
  name: 'manage-publsihers',
  components: {
    DataTable,
    Card,
    CardHeader,
    CardTitle,
    CardContent,
    Button,
    AlertDialog,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogAction,
    AlertDialogCancel,
    ShoppingBasket,
  },
  props: {},

  data() {
    return {
      serverOptions: {
        page: 1,
        rowsPerPage: 25,
      },
      serverItemsLength: undefined,
      uploadCSV: undefined,
      verification: undefined,

      showErrorModal: false,
      showSuccessModal: false,
      openUploadModal: false,
      loading: true,
      error: false,
      headersTable1: [
        { text: 'Created on', value: 'createdOn' },
        { text: 'Download CSV', value: 'downloadCSV' },
      ],
      receivables: [],
    }
  },
  created() {
    this.getTransactionVerifications(0, 25)
  },
  methods: {
    niceDateTime(dateObject) {
      return DateTime.fromMillis(dateObject).toLocaleString(DateTime.DATE_MED)
    },

    uploadFile: function () {
      // const file = event.target.files[0];
      this.uploadCSV = event.target.files[0]
    },

    async uploadTransactions() {
      const formData = new FormData()
      formData.append('multipartFile', this.uploadCSV)

      try {
        const token = localStorage.getItem('token')
        this.loading = true

        const response = await this.$apiFetch(
          `${localStorage.getItem('apiUrl')}/private/api/client/bring-your-own-offer-fulfillment/upload`,
          {
            method: 'POST',
            body: formData,
            headers: {
              Authorization: `${token}`,
            },
          }
        )

        if (response.ok) {
          this.openUploadModal = false
        }
      } catch (error) {
        return
      }
    },

    async getTransactionVerifications(page, size) {
      const token = localStorage.getItem('token')
      this.loading = true
      this.error = false
      try {
        const response = await this.$apiFetch(
          `${localStorage.getItem('apiUrl')}/private/api/client/bring-your-own-offer-fulfillment?page=${page}&size=${size}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `${token}`,
            },
          }
        )

        if (response.ok) {
          var object = await response.json()

          this.serverItemsLength = object.totalElements
          this.receivables = object.content
        } else {
          this.error = true
        }
      } catch (e) {
        this.error = true
      } finally {
        this.loading = false
      }
    },

    async download(transactionVerification) {
      try {
        const token = localStorage.getItem('token')

        this.loading = true

        const response = await this.$apiFetch(
          `${localStorage.getItem('apiUrl')}/private/api/client/bring-your-own-offer-fulfillment/${transactionVerification.id}/download`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `${token}`,
            },
          }
        )

        if (response.ok) {
          const blob = await response.blob() // Convert the response to a blob
          const url = window.URL.createObjectURL(blob) // Create a URL for the blob

          // Create a link element and set its href to the blob URL
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `transaction_verification_boogi_${transactionVerification.id}.csv`
          ) // Set the desired file name

          document.body.appendChild(link)
          link.click() // Programmatically click the link to trigger download

          document.body.removeChild(link) // Remove the link after the download is triggered
        } else {
          console.error('Failed to download CSV')
        }
      } catch (error) {
        console.error('Error downloading CSV:', error)
      } finally {
        this.loading = false // Stop loading
      }
    },
  },
  computed: {},
  watch: {
    serverOptions: {
      deep: true,
      handler(val) {
        this.getTransactionVerifications(val.page - 1, val.rowsPerPage)
      },
    },
  },
}
</script>
